import { connect } from 'react-redux'
import { email } from 'util/validation'
import withFormFields from 'shared/ui/Form/withFormFields'

import { doSwitchInputMode, doMultiInputFormSubmit } from '../actions'
import {
  selectMultiInputFormFields,
  selectInputMode,
  selectInvitationErrors,
  selectBackPageType,
} from '../selectors'

import AddTeamMembersMultiInputFormView from './view'

function validateMultiEmailInput(value) {
  let lastResponse = null
  value
    .split('\n')
    .filter(emailValue => emailValue.trim() !== '')
    .some(emailValue => {
      lastResponse = email(emailValue)
      return lastResponse !== null
    })
  return lastResponse
}

const validators = {
  multiEmailAddressInput: validateMultiEmailInput,
}

const select = state => ({
  initialValues: selectMultiInputFormFields(state),
  validators,
  inputMode: selectInputMode(state),
  invitationErrors: selectInvitationErrors(state),
  backPageType: selectBackPageType(state),
})

const perform = {
  switchInputMode: doSwitchInputMode,
  onSave: doMultiInputFormSubmit,
}

export default connect(select, perform)(
  withFormFields(AddTeamMembersMultiInputFormView)
)
